export default "__VITE_ASSET__rcDlTlA9__"